import { useMemo } from 'react';

import { useNavigation } from '~/src/queries/api-ecom/generated/api-ecom';

import { useBreadcrumbFromId } from './useBreadcrumbFromId';

/**
 * Génère le fil d'ariane (breadcrumb) à partir des noms de catégorie et sous-catégorie.
 *
 * Note: Cette méthode est une solution transitoire pour assurer la compatibilité avec l'existant.
 * À terme, la nouvelle implémentation des analytics ATC permettra de récupérer les informations
 * directement par ID, offrant un mécanisme plus robuste pour personnaliser le fil d'ariane.
 */
export const useBreadcrumbFromName = (catName: string | null, subcatName: string | null) => {
  const { data: nav } = useNavigation();

  // Recherche de la sous-cat via les noms
  const idOrSlug = useMemo(() => {
    if (nav == null || catName == null || subcatName == null) return null;
    // Applatissage de la navigation pour simplifier la recherche
    const entry = [nav.home, nav.recipe, ...nav.families.flatMap(f => f.categories)]
      .flatMap(cat => cat.children.map(subcat => ({ cat, subcat })))
      .find(item => item.subcat.name === subcatName && item.cat.name === catName);
    // Si un élément est trouvé, on remonte son ID
    return entry ? entry.subcat.id : null;
  }, [nav, catName, subcatName]);

  // Puis la main est passée à la version moderne
  return useBreadcrumbFromId(idOrSlug);
};
